import React from 'react'
import '../assets/css/errorPage.css'


export default function ErrorPage() {
    return (
        <div className="container ePage">
            <div className="eWrapper">
                <div className="eImgWraper mb-5">
                </div>
                <div className="eTitle">This page is taking way too long to load.</div>
                <p>Sorry about that. Please try refreshing and contact us if the problem persists.</p>
            </div>
        </div>
    )
}
